import {SharedIssueConnectedApiService} from '@shared/components/issues/services/shared-issue-connected-api.service';
import { Injectable, inject } from "@angular/core";
import {IssueContentType, IssueType} from "@server-models";
import {LinkIssueMessageApiService} from "@link/pages/issues/services/link-issue-message-api.service";
import {LinkIssueMissionApiService} from "@link/pages/issues/services/link-issue-mission-api.service";
import {LinkIssueTicketApiService} from "@link/pages/issues/services/link-issue-ticket-api.service";
import {IIssueService} from "@shared/components/issues/interfaces/issue-service.interface";
import {LinkIssueControlMessageApiService} from "@link/pages/issues/services/link-issue-control-message-api.service";
import {LinkIssueDirectMessageApiService} from "@link/pages/issues/services/link-issue-direct-message-api.service";

@Injectable({
  providedIn: 'root',
})
export class LinkIssueService {
  private readonly _linkIssueConnectedService = inject(SharedIssueConnectedApiService);
  private _linkIssuesMessageApiService = inject(LinkIssueMessageApiService);
  private _linkIssuesDirectMessageApiService = inject(LinkIssueDirectMessageApiService);
  private _linkIssuesMissionApiService = inject(LinkIssueMissionApiService);
  private _linkIssuesTicketApiService = inject(LinkIssueTicketApiService);
  private _linkIssuesControlMessageApiService = inject(LinkIssueControlMessageApiService);


  previewConnected(templateId: number, resourceId?: number) {
    return this._linkIssueConnectedService.previewConnected(templateId, resourceId);
  }

  getApiServiceByIssueType(issueType: IssueType): IIssueService {
    switch (issueType) {
      case IssueType.Connected:
        return this._linkIssueConnectedService;
      case IssueType.Message:
        return this._linkIssuesMessageApiService;
      case IssueType.DirectMessage:
        return this._linkIssuesDirectMessageApiService;
      case IssueType.Mission:
        return this._linkIssuesMissionApiService;
      case IssueType.Ticket:
        return this._linkIssuesTicketApiService;
      case IssueType.ControlMessage:
        return this._linkIssuesControlMessageApiService;
      default:
        throw new Error(`Api service, Unsupported issue type: ${ issueType }`);
    }
  }

  getApiServiceByIssueContentType(issueContentType: IssueContentType): IIssueService {
    switch (issueContentType) {
      case IssueContentType.Connected:
        return this._linkIssueConnectedService;
      case IssueContentType.Message:
        return this._linkIssuesMessageApiService;
      case IssueContentType.DirectMessage:
        return this._linkIssuesDirectMessageApiService;
      case IssueContentType.Mission:
        return this._linkIssuesMissionApiService;
      case IssueContentType.Ticket:
        return this._linkIssuesTicketApiService;
      default:
        throw new Error(`Api service, Unsupported issue content type: ${ issueContentType }`);
    }
  }
}
